module.exports = __webpack_public_path__ + "img/baoguan.d48df4d9.png";